import { useMemo } from 'react';
import { useUserRole } from './useUserRole';
import { useAcademyContext } from './useAcademyContext';

export type EffectiveRole = 'admin' | 'gestor' | 'professor' | 'aluno';

/**
 * Resolves the user's effective role considering both global role (user_roles)
 * and academy membership role (academy_members).
 * Priority: admin > academy role > global role
 */
export function useEffectiveRole() {
  const { role: globalRole, loading: roleLoading, isAdmin } = useUserRole();
  const { currentRole: academyRole, isLoading: academyLoading } = useAcademyContext();

  const loading = roleLoading || academyLoading;

  let effectiveRole: EffectiveRole = 'professor'; // default

  if (isAdmin) {
    effectiveRole = 'admin';
  } else if (academyRole) {
    effectiveRole = academyRole as EffectiveRole;
  } else if (globalRole === 'aluno') {
    effectiveRole = 'aluno';
  } else if (globalRole === 'academia') {
    effectiveRole = 'gestor';
  } else {
    effectiveRole = 'professor';
  }

  // P1-B: memoize to keep stable reference across re-renders (e.g. active Timer).
  return useMemo(() => ({
    effectiveRole,
    loading,
    isAdmin: effectiveRole === 'admin',
    isGestor: effectiveRole === 'gestor',
    isProfessor: effectiveRole === 'professor',
    isAluno: effectiveRole === 'aluno',
    isTeacherOrAbove: effectiveRole !== 'aluno',
  }), [effectiveRole, loading]);
}
